import { Component, OnInit, Input } from '@angular/core';
import { DataService } from '../data.service';

@Component({
  selector: 'app-photogallery',
  templateUrl: './photogallery.component.html',
  styleUrls: ['./photogallery.component.css']
})
export class PhotogalleryComponent implements OnInit {
    public arrData = new Array<any>();
    public arrTable = new Array<any>();
    public arrTable1 = new Array<any>();
    @Input() webpagedefinitionitemid: number; 
    @Input() docid: number;
    @Input() webpagelayoutitemid: number;
    @Input() webpagethemeelementid: number;
    @Input() cache: boolean;

    constructor(public dataservice: DataService) { }

    ngOnInit() {
        this.dataservice.getElementData(this.webpagedefinitionitemid, this.docid, this.webpagelayoutitemid, this.webpagethemeelementid, this.cache, 'g2/photogallery', (returndata: any) => {
            this.arrData = returndata;
            this.arrTable = returndata.Table;
            this.arrTable1 = returndata.Table1;
        }, '');
    }
}
